import styled from 'styled-components'

const StyledSuccess = styled.div`
  font-size: 1.4rem;
  text-align: center;
  p {
    margin: 0;
  }
  .status-img {
    width: 30rem;
    margin: 5rem auto 2rem;
    display: block;
  }
  .action {
    margin: 1.5rem 0;
    color: #fff;
  }

  @media screen and (max-width: 50rem) {
    .status-img {
      max-width: 100%;
      margin: 1rem auto;
    }
  }
`

export default StyledSuccess
